export default __webpack_public_path__ + "static/media/acqua.c57c1358.jpg";